import { render, staticRenderFns } from "./merchant-settings.vue?vue&type=template&id=a9ef30c0&"
import script from "./merchant-settings.vue?vue&type=script&lang=js&"
export * from "./merchant-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports